(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list/assets/javascripts/game-list.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list/assets/javascripts/game-list.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState,
  useCallback = _React.useCallback;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const _ReactRouterDOM = ReactRouterDOM,
  useLocation = _ReactRouterDOM.useLocation,
  useHistory = _ReactRouterDOM.useHistory;
const Button = svs.ui.ReactButton;
const Loader = svs.components.ReactLoader.Loader;
const GroupList = svs.components.marketplace.groupList.GroupList;
const GameSkeleton = svs.components.marketplace.gameList.GameSkeleton;
const getTeamUrl = svs.components.marketplace.helpers.getTeamUrl;
const _svs$components$marke = svs.components.marketplaceData.selectors.games,
  selectGames = _svs$components$marke.selectGames,
  getIsLoading = _svs$components$marke.getIsLoading,
  getBrowseGames = _svs$components$marke.getBrowseGames,
  getIsBrowseGamesLoading = _svs$components$marke.getIsBrowseGamesLoading,
  getActiveGamesFetchedCount = _svs$components$marke.getActiveGamesFetchedCount,
  getActiveGamesFetchableCount = _svs$components$marke.getActiveGamesFetchableCount;
const selectTeam = svs.components.marketplaceData.selectors.teams.selectTeam;
const actionsMockable = svs.components.marketplaceData.games.actions;
const roles = svs.components.marketplaceData.auth.roles;
const GameContainer = svs.components.marketplace.gameList.GameContainer;
const MAX_GAMES_TO_DISPLAY_ALL = svs.components.marketplaceData.gamesConstants.MAX_GAMES_TO_DISPLAY_ALL;
const GameList = _ref => {
  let className = _ref.className,
    fromTeamList = _ref.fromTeamList,
    gameLinkSearch = _ref.gameLinkSearch,
    groupId = _ref.groupId,
    hasBottomBorder = _ref.hasBottomBorder,
    isListing = _ref.isListing,
    isTeamView = _ref.isTeamView,
    isRetail = _ref.isRetail,
    maxGamesToDisplayProp = _ref.maxGamesToDisplay,
    _ref$hasNoFractionPay = _ref.hasNoFractionPayment,
    hasNoFractionPayment = _ref$hasNoFractionPay === void 0 ? false : _ref$hasNoFractionPay,
    noFetch = _ref.noFetch,
    isBrowseGames = _ref.isBrowseGames,
    offsetForLastClicked = _ref.offsetForLastClicked;
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const games = useSelector(state => {
    const selectedGames = isBrowseGames ? getBrowseGames(state, {
      groupId
    }) : selectGames(state, {
      groupId
    }) || [];
    if (selectedGames === undefined || selectedGames.length === 0) {
      return [];
    }
    return selectedGames.map(game => {
      if (game.drawCloseTime) {
        return _objectSpread(_objectSpread({}, game), {}, {
          drawCloseTime: typeof game.drawCloseTime === 'string' ? new Date(game.drawCloseTime) : game.drawCloseTime
        });
      }
      return game;
    });
  });
  const isLoading = useSelector(state => isBrowseGames ? getIsBrowseGamesLoading(state) : getIsLoading(state, {
    groupId
  }));
  const _useSelector = useSelector(state => selectTeam(state, {
      id: groupId
    })),
    groupName = _useSelector.name,
    role = _useSelector.role;
  const maxGamesToDisplay = maxGamesToDisplayProp === MAX_GAMES_TO_DISPLAY_ALL ? games.length : maxGamesToDisplayProp;
  const isLazyLoadingGamesList = isTeamView;
  const _checkIfHadLazyLoadingBeforeShowingGameDetails = () => isLazyLoadingGamesList && games.length > 20;
  const _useState = useState(_checkIfHadLazyLoadingBeforeShowingGameDetails()),
    _useState2 = _slicedToArray(_useState, 2),
    isInfiniteScrollMode = _useState2[0],
    setIsInfiniteScrollMode = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasToFetchMore = _useState4[0],
    setHasToFetchMore = _useState4[1];
  const activeGamesFetched = useSelector(state => getActiveGamesFetchedCount(state, {
    groupId
  }));
  const activeGamesFetchable = useSelector(state => getActiveGamesFetchableCount(state, {
    groupId
  }));
  const loadDataRef = useRef(null);
  const lazyLoadingRef = useRef({
    intersectionObserver: null,
    observedElement: null,
    updatedData: {
      activeGamesFetched: 0,
      isLoading: false,
      hasMoreData: false
    }
  });
  lazyLoadingRef.current.updatedData = {
    activeGamesFetched,
    isLoading,
    hasMoreData: activeGamesFetched < activeGamesFetchable
  };
  const hasFetchMoreButton = isLazyLoadingGamesList && !isInfiniteScrollMode && lazyLoadingRef.current.updatedData.hasMoreData;
  useEffect(() => {
    if (isLazyLoadingGamesList) {
      const current = lazyLoadingRef.current;
      current.intersectionObserver = new IntersectionObserver(entries => {
        const hasLoadDataIntersect = entries.some(item => item.isIntersecting && item.target === loadDataRef.current);
        if (hasLoadDataIntersect && current.updatedData.hasMoreData && !current.updatedData.isLoading) {
          setHasToFetchMore(true);
          current.intersectionObserver.unobserve(loadDataRef.current);
          current.observedElement = null;
        }
      });
      return () => {
        current.intersectionObserver.disconnect();
        current.observedElement = null;
      };
    }
  }, [isLazyLoadingGamesList]);
  if (isInfiniteScrollMode && !hasToFetchMore) {
    if (loadDataRef.current && loadDataRef.current !== lazyLoadingRef.current.observedElement) {
      lazyLoadingRef.current.intersectionObserver.observe(loadDataRef.current);
      lazyLoadingRef.current.observedElement = loadDataRef.current;
    }
  }
  useEffect(() => {
    if (groupId && !noFetch) {
      dispatch(actionsMockable.fetchGamesAction({
        groupId,
        offset: 0
      }));
    }
  }, [dispatch, groupId, noFetch]);
  useEffect(() => {
    if (groupId && hasToFetchMore && !noFetch) {
      if (isLoading) {
        setHasToFetchMore(false);
      } else {
        dispatch(actionsMockable.fetchGamesAction({
          groupId,
          offset: lazyLoadingRef.current.updatedData.activeGamesFetched
        }));
      }
    }
  }, [hasToFetchMore, isLoading, noFetch, dispatch, groupId]);
  const onCreateTeam = useCallback(() => {
    history.push({
      pathname: getTeamUrl(groupId, groupName, 'skapa-spel'),
      state: {
        internalLink: true
      }
    });
  }, [groupId, groupName, history]);
  const renderOnEmpty = () => {
    const title = isRetail ? 'Inga förberedda spel' : 'Laget har inga spel just nu';
    const isCaptainOrAdmin = role === roles.ROLES.CAPTAIN || role === roles.ROLES.ADMIN;
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "no-games-container-link"
    }, React.createElement("div", {
      className: "no-games-container-holder"
    }, React.createElement("div", {
      className: "no-games-container",
      "data-testid": "qa-no-games-container"
    }, React.createElement("p", {
      className: "game-list-info-text"
    }, title)))), isCaptainOrAdmin && React.createElement("div", {
      className: "no-games-container-btn",
      "data-testid": "qa-no-games-container-btn"
    }, React.createElement(Button, {
      block: true,
      onClick: () => onCreateTeam(),
      size: 100,
      transparent: true
    }, "Skapa ett nytt spel")));
  };
  const classNames = ['game-list-container'];
  className && classNames.push(className);
  if (isLoading && !isInfiniteScrollMode) {
    return React.createElement("div", {
      className: classNames.join(' '),
      "data-testid": "qa-game-list-container-loading"
    }, React.createElement(GameSkeleton, null), React.createElement(GameSkeleton, null));
  }
  if (games.length === 0 && !isListing) {
    return renderOnEmpty();
  }
  if (games.length === 0) {
    return null;
  }
  return React.createElement("div", {
    className: classNames.join(' '),
    "data-testid": "qa-game-list-container"
  }, React.createElement(GroupList, {
    listData: games.slice(0, maxGamesToDisplay),
    renderItem: (game, gameIndex) => React.createElement(GameContainer, {
      fromTeamList: fromTeamList,
      game: game,
      gameIndex: gameIndex,
      gameLinkSearch: gameLinkSearch,
      groupId: groupId,
      groupName: groupName,
      hasBottomBorder: hasBottomBorder,
      hasNoFractionPayment: hasNoFractionPayment,
      isListing: isListing,
      isRetail: isRetail,
      key: game.activatedDrawId,
      location: location,
      offsetForLastClicked: offsetForLastClicked,
      role: role
    })
  }), Boolean(isLazyLoadingGamesList) && React.createElement("div", {
    ref: loadDataRef
  }), isLoading && React.createElement("div", {
    className: "loader-holder"
  }, React.createElement(Loader, {
    inverted: true
  })), Boolean(hasFetchMoreButton) && React.createElement("div", {
    className: "fetch-game-button-container"
  }, React.createElement(Button, {
    className: "qa-fetch-game-btn",
    onClick: () => setIsInfiniteScrollMode(true),
    transparent: true
  }, "VISA FLER SPEL")));
};
GameList.defaultProps = {
  className: '',
  hasBottomBorder: false,
  isRetail: false,
  noFetch: false
};
setGlobal('svs.components.marketplace.gameList.GameList', GameList);

 })(window);